import Cookies from 'js-cookie'

const TokenKey = 'NFSEDATTA-Token';

const TimeEndKey = 'NFSEDATTA-TimeEnd';

const TokenKeyEmpresa = 'NFSEDATTA-Empresa';

const EntCNPJ = 'ENT-CNPJ';

const tempoToken = (process.env.NODE_ENV === 'development') ? 100 : 0.32;

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, {expires: tempoToken})
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getTimeEnd() {
    return Cookies.get(TimeEndKey)
}

export function setTimeEnd(time) {
    return Cookies.set(TimeEndKey, time, {expires: tempoToken})
}

export function removeTimeEnd() {
    return Cookies.remove(TimeEndKey)
}

export function getEmpresa() {
    return Cookies.get(TokenKeyEmpresa)
}

export function setEmpresa(empresa) {
    return Cookies.set(TokenKeyEmpresa, empresa, {expires: 300})
}

export function getEntCnpj() {
    return Cookies.get(EntCNPJ)
}

export function setEntCnpj(cnpj) {
    return Cookies.set(EntCNPJ, cnpj, {expires: 300})
}

export function removeEntCnpj() {
    return Cookies.remove(EntCNPJ)
}
